/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Next_DifferenceInputs */



/**
* | output |
* | --- |
* | "Next Difference" |
*
* @param {Compare_Event_Groups_Next_DifferenceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_next_difference = /** @type {((inputs?: Compare_Event_Groups_Next_DifferenceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Next_DifferenceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Différence suivante")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nächster Unterschied")
	if (locale === "it") return /** @type {LocalizedString} */ ("Differenza successiva")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Следующая разница")
	if (locale === "es") return /** @type {LocalizedString} */ ("Próxima diferencia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下一个区别")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次の違い")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगला अंतर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Próxima diferença")
	return /** @type {LocalizedString} */ ("Next Difference")
});